import { createFileRoute, redirect } from '@tanstack/react-router';

// Any unmatched path falls back to login (replaces the react-router `*` → /login catch-all).
export const Route = createFileRoute('/$')({
  beforeLoad: () => {
    throw redirect({ to: '/login' });
  },
});
